// Overlay decorativo da Copa: confetes caindo, bandeirinhas (bunting) balançando
// no topo, bolas de futebol e bandeiras do Brasil flutuando nas laterais.
// Renderizado apenas quando o tema "copa-brasil" está ativo (controle no CardapioPublico).
//
// Por que JS injeta as bandeirinhas/confetes em vez de Array.from no JSX:
// quantidade é função do width da viewport e cada peça tem animação aleatória
// — em JSX puro seria ~50 nodes com inline styles distintos. JS imperativo
// fica mais legível e o cleanup garante zero leak ao desmontar.
import React, { useEffect, useRef } from "react";

const FLAG_BRASIL = "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/330px-Flag_of_Brazil.svg.png";

export default function CopaOverlay() {
  const confettiRef = useRef(null);
  const buntingRef = useRef(null);

  useEffect(() => {
    const confetti = confettiRef.current;
    const bunting = buntingRef.current;

    // Confetes — cores Brasil + branco pra contraste no fundo escuro
    if (confetti) {
      const colors = ["#009C3B", "#FFD500", "#00A651", "#FFE000", "#FFD200", "#ffffff"];
      const count = window.innerWidth < 560 ? 32 : 56;
      const frag = document.createDocumentFragment();
      for (let i = 0; i < count; i++) {
        const p = document.createElement("div");
        p.className = "copa-confetti-piece";
        p.style.left = Math.random() * 100 + "%";
        p.style.background = colors[i % colors.length];
        p.style.animationDuration = (5 + Math.random() * 6).toFixed(2) + "s";
        p.style.animationDelay = (-Math.random() * 8).toFixed(2) + "s";
        p.style.opacity = (0.5 + Math.random() * 0.4).toFixed(2);
        p.style.transform = "scale(" + (0.7 + Math.random() * 0.7).toFixed(2) + ")";
        frag.appendChild(p);
      }
      confetti.appendChild(frag);
    }

    // Bandeirinhas (bunting) — quantidade adapta ao width
    if (bunting) {
      const n = Math.min(24, Math.ceil(window.innerWidth / 30));
      const frag = document.createDocumentFragment();
      for (let i = 0; i < n; i++) {
        const f = document.createElement("div");
        f.className = "copa-flag";
        f.style.animationDelay = (-(i % 5) * 0.5).toFixed(2) + "s";
        frag.appendChild(f);
      }
      bunting.appendChild(frag);
    }

    return () => {
      if (confetti) confetti.innerHTML = "";
      if (bunting) bunting.innerHTML = "";
    };
  }, []);

  return (
    <>
      <div className="copa-confetti" ref={confettiRef} aria-hidden />
      <div className="copa-bunting" ref={buntingRef} aria-hidden />
      {/* Decorações laterais — bolas + bandeiras alternando, posições espalhadas */}
      <span className="copa-ball-deco" style={{ top: "10%", left: "3%" }} aria-hidden>⚽</span>
      <img
        className="copa-ball-deco copa-flag-img"
        style={{ top: "28%", left: "2%", animationDelay: "-2s" }}
        src={FLAG_BRASIL}
        alt=""
        aria-hidden
      />
      <span className="copa-ball-deco" style={{ top: "48%", left: "3%", animationDelay: "-1.5s" }} aria-hidden>⚽</span>
      <span className="copa-ball-deco" style={{ top: "72%", left: "2%", animationDelay: "-3.5s" }} aria-hidden>⚽</span>
      <span className="copa-ball-deco" style={{ top: "12%", right: "3%", animationDelay: "-0.8s" }} aria-hidden>⚽</span>
      <img
        className="copa-ball-deco copa-flag-img"
        style={{ top: "35%", right: "2%", animationDelay: "-1s" }}
        src={FLAG_BRASIL}
        alt=""
        aria-hidden
      />
      <span className="copa-ball-deco" style={{ top: "60%", right: "3%", animationDelay: "-2.5s" }} aria-hidden>⚽</span>
      <span className="copa-ball-deco" style={{ top: "80%", right: "2.5%", animationDelay: "-3s" }} aria-hidden>⚽</span>
    </>
  );
}
